import type { Unit } from "./types";
import { MAX_HP } from "./units";

export function unitTotalHp(unit: Pick<Unit, "hp">): number {
  return Math.max(0, Math.min(unit.hp, MAX_HP));
}

export function normalizedHpPercent(hp: number): number {
  const hpNow = Math.max(0, Math.min(hp, MAX_HP));
  if (hpNow <= 0) return 0;
  return Math.ceil(hpNow / 10) * 10;
}

export function normalizedHpDisplay(hp: number): number {
  if (hp <= 0) return 0;
  return Math.ceil(normalizedHpPercent(hp) / 10);
}

export const HP_DISPLAY_MAX = MAX_HP / 10;

export function displayHpToInternal(displayHp: number): number {
  return Math.max(0, Math.min(MAX_HP, displayHp * 10));
}

export function applyDamageToStacks({ unit, damage }: { unit: Unit; damage: number }): {
  hp: number;
  killed: boolean;
} {
  const currentHp = unitTotalHp(unit);
  if (damage <= 0 || currentHp <= 0) {
    return { hp: currentHp, killed: currentHp <= 0 };
  }
  const hp = Math.max(0, currentHp - damage);
  return { hp, killed: hp <= 0 };
}
